// This file is autogenerated. Any changes will be overwritten.

const iconNames = [
  '1-1-solid',
  '1-1',
  'a11y',
  'ai-assist',
  'align-center',
  'align-item-center-solid',
  'align-item-center',
  'align-item-down-solid',
  'align-item-down',
  'align-item-left-solid',
  'align-item-left',
  'align-item-right-solid',
  'align-item-right',
  'align-item-up-solid',
  'align-item-up',
  'align-item-vert-center-solid',
  'align-item-vert-center',
  'align-left',
  'align-right',
  'amazon',
  'ambulance-solid',
  'ambulance',
  'analytics-bad-solid',
  'analytics-bad',
  'analytics-good-solid',
  'analytics-good',
  'analytics-neutral-solid',
  'analytics-neutral',
  'antenna',
  'app-solid',
  'app',
  'archery',
  'archive-solid',
  'archive',
  'arrow-above-or',
  'arrow-above-row-left',
  'arrow-above-row-right',
  'arrow-below-or',
  'arrow-below-row-left',
  'arrow-below-row-right',
  'arrow-bend-left',
  'arrow-bend-right',
  'arrow-between-column-down',
  'arrow-down-between-left-column',
  'arrow-down-between-right-column',
  'arrow-down-row',
  'arrow-down',
  'arrow-in',
  'arrow-left-column',
  'arrow-left-right',
  'arrow-left',
  'arrow-micro-down',
  'arrow-micro-left',
  'arrow-micro-right',
  'arrow-micro-up-down',
  'arrow-micro-up',
  'arrow-out',
  'arrow-right-between-rows',
  'arrow-right-column',
  'arrow-right',
  'arrow-up-down',
  'arrow-up-row',
  'arrow-up',
  'atom',
  'automation-call',
  'backspace-solid',
  'backspace',
  'badge-solid',
  'badge',
  'bank-solid',
  'bank',
  'bars',
  'battery-charge-solid',
  'battery-charge',
  'battery-solid',
  'battery',
  'bell-off-solid',
  'bell-off',
  'bell-solid',
  'bell',
  'blocks-solid',
  'blocks',
  'bluetooth',
  'bolt-solid',
  'bolt',
  'book-open-solid',
  'book-open',
  'book-solid',
  'book',
  'bookmark-solid',
  'bookmark',
  'bounding-box-solid',
  'bounding-box',
  'box-3-solid',
  'box-3',
  'box-4-solid',
  'box-4',
  'box-crosshair',
  'box-dashed-labeled-solid',
  'box-dashed-labeled',
  'box-grid',
  'box-lines-2-solid',
  'box-lines-2',
  'box',
  'brain',
  'branch',
  'browser-solid',
  'browser',
  'bug-solid',
  'bug',
  'building-2-solid',
  'building-2',
  'building-3-solid',
  'building-3',
  'building-solid',
  'building',
  'bulb-solid',
  'bulb',
  'calculator-solid',
  'calculator',
  'calendar-empty-solid',
  'calendar-empty',
  'calendar-now',
  'calendar-plus-solid',
  'calendar-plus',
  'calendar-range',
  'calendar-solid',
  'calendar',
  'camera-solid',
  'camera',
  'cancel',
  'car-solid',
  'car',
  'card-stack-solid',
  'card-stack',
  'caret-2-left',
  'caret-2-right',
  'caret-down',
  'caret-left',
  'caret-right',
  'caret-up',
  'carrot',
  'cart-close-solid',
  'cart-close',
  'cart-solid',
  'cart',
  'case-medical-solid',
  'case-medical',
  'case-solid',
  'case',
  'chain-solid',
  'chain-up',
  'chain',
  'chat-help-solid',
  'chat-help',
  'chat-sentiment-solid',
  'chat-sentiment',
  'chat-solid',
  'chat-typing-solid',
  'chat-typing',
  'chat',
  'chats-solid',
  'chats',
  'check-solid',
  'check',
  'checkbook',
  'chevron-solid',
  'chevron',
  'church-solid',
  'church',
  'circle-mixed-down',
  'circle-mixed-left',
  'circle-mixed-up',
  'circle-solid',
  'circle-stacked-mixed',
  'circle-stacked-solid',
  'circle-stacked',
  'circle',
  'city-solid',
  'city',
  'clipboard-check-solid',
  'clipboard-check',
  'clipboard-data-solid',
  'clipboard-data',
  'clipboard-medical-solid',
  'clipboard-medical',
  'clipboard-plus-solid',
  'clipboard-plus',
  'clipboard-solid',
  'clipboard',
  'clock-sla',
  'clock-solid',
  'clock',
  'cloud-down',
  'cloud-issue-solid',
  'cloud-issue',
  'cloud-solid',
  'cloud-up',
  'cloud',
  'cloudy-solid',
  'cloudy',
  'code',
  'column-delete',
  'column-insert',
  'column-no-left',
  'column-no-right',
  'column-top-fill',
  'columns-solid',
  'columns',
  'command',
  'compass-solid',
  'compass',
  'condition-critical',
  'condition-satisfactory',
  'controller-solid',
  'controller',
  'copy-solid',
  'copy',
  'credit-solid',
  'credit',
  'crop',
  'crosshairs',
  'cuppa-solid',
  'cuppa',
  'dataviz-area-multi',
  'dataviz-area-stacked',
  'dataviz-area',
  'dataviz-bar-clustered',
  'dataviz-bar-stacked',
  'dataviz-bar',
  'dataviz-bubble',
  'dataviz-column-clustered',
  'dataviz-column-stacked',
  'dataviz-column',
  'dataviz-combo',
  'dataviz-datetime-field',
  'dataviz-donut',
  'dataviz-flip-counter',
  'dataviz-forecast',
  'dataviz-funnel-solid',
  'dataviz-funnel',
  'dataviz-gauge',
  'dataviz-geo-choropleth',
  'dataviz-line-multi',
  'dataviz-line',
  'dataviz-numeric-field',
  'dataviz-pareto',
  'dataviz-pie',
  'dataviz-pivot-table',
  'dataviz-radar',
  'dataviz-scatter',
  'dataviz-spark',
  'dataviz-string-field',
  'dataviz-table-with-bars',
  'dataviz-table-with-cross',
  'dataviz-waterfall',
  'desktop-solid',
  'desktop',
  'diamond-minus',
  'diamond-solid',
  'diamond',
  'disc-stack-solid',
  'disc-stack',
  'distribute-item-center-solid',
  'distribute-item-center',
  'distribute-item-vert-center-solid',
  'distribute-item-vert-center',
  'dna',
  'dock',
  'document-check-solid',
  'document-check',
  'document-compress-solid',
  'document-compress',
  'document-data-solid',
  'document-doc',
  'document-download-solid',
  'document-download',
  'document-minus-solid',
  'document-minus',
  'document-pdf',
  'document-plus-solid',
  'document-plus',
  'document-solid',
  'document-upload-solid',
  'document-upload',
  'document-xls',
  'document',
  'documents-check-solid',
  'documents-check',
  'documents-data-solid',
  'documents-data',
  'documents-solid',
  'documents',
  'docusign',
  'dollar-sign-solid',
  'dollar-sign',
  'dot-9-solid',
  'dot-9',
  'download',
  'drag',
  'drink-solid',
  'drink',
  'earth-solid',
  'earth',
  'edit-shape-solid',
  'edit-shape',
  'erase-solid',
  'erase',
  'eye-off-solid',
  'eye-off',
  'eye-solid',
  'eye',
  'face-blank-solid',
  'face-blank',
  'face-happy-solid',
  'face-happy',
  'face-sad-solid',
  'face-sad',
  'facebook',
  'farm-solid',
  'farm',
  'fast-forward-solid',
  'fast-forward',
  'field-dot',
  'filetype-text',
  'filter-on',
  'filter',
  'fire-solid',
  'fire',
  'flag-finish',
  'flag-solid',
  'flag-wave-solid',
  'flag-wave',
  'flag',
  'flashlight-solid',
  'flashlight',
  'folder-close-solid',
  'folder-close',
  'folder-closed-solid',
  'folder-closed',
  'folder-dollar-solid',
  'folder-dollar',
  'folder-hierarchy-solid',
  'folder-hierarchy',
  'folder-nested-solid',
  'folder-nested',
  'folder-plus-solid',
  'folder-plus',
  'folder-solid',
  'folder',
  'folders-solid',
  'folders',
  'forward-all-solid',
  'forward-all',
  'forward-solid',
  'forward',
  'freeze-column',
  'function',
  'galaxy',
  'gauge-solid',
  'gauge',
  'gear-box-dotted',
  'gear-solid',
  'gear',
  'glasses-solid',
  'glasses',
  'globe-solid',
  'globe',
  'google',
  'government-solid',
  'government',
  'grad-solid',
  'grad',
  'grid-solid',
  'grid',
  'hand-solid',
  'hand',
  'handshake-solid',
  'handshake',
  'hanger',
  'header',
  'headline-solid',
  'headline',
  'headphone-solid',
  'headphone',
  'headset',
  'heart-mixed',
  'heart-pulse-solid',
  'heart-pulse',
  'heart-solid',
  'heart',
  'help-solid',
  'help',
  'history-solid',
  'history',
  'home-alt-solid',
  'home-alt',
  'home-solid',
  'home',
  'inbox-data-solid',
  'inbox-data',
  'inbox-empty',
  'inbox-solid',
  'indent',
  'infinity',
  'information-solid',
  'information',
  'ink-solid',
  'ink',
  'input-pen',
  'inspect',
  'interact',
  'ios-face-id',
  'ios-finger-id',
  'key',
  'keyboard-solid',
  'keyboard',
  'knight-solid',
  'knight',
  'knobs-alt-solid',
  'knobs-alt',
  'knobs-solid',
  'knobs',
  'laptop-solid',
  'laptop',
  'layers-solid',
  'layers',
  'layout-solid',
  'layout',
  'leaf-solid',
  'leaf',
  'legal',
  'letter-solid',
  'letter',
  'life-ring-solid',
  'life-ring',
  'linkedin',
  'list-number',
  'list',
  'live-transcript',
  'location-check-solid',
  'location-check',
  'location-solid',
  'location',
  'locations-solid',
  'locations',
  'lock-closed-solid',
  'lock-closed',
  'lock-open-solid',
  'lock-open',
  'magnet-solid',
  'magnet',
  'mail-check-solid',
  'mail-check',
  'mail-plus-solid',
  'mail-plus',
  'mail-solid',
  'mail',
  'mailbox-solid',
  'mailbox',
  'map-sigma-solid',
  'map-sigma',
  'map-solid',
  'map',
  'material-finger',
  'mcp',
  'medal',
  'megaphone-solid',
  'megaphone',
  'mic-off-solid',
  'mic-off',
  'mic-solid',
  'mic',
  'minus',
  'mobile-phone-solid',
  'mobile-phone',
  'money-send-solid',
  'money-send',
  'money-solid',
  'money',
  'monkey-solid',
  'monkey',
  'moon-solid',
  'moon',
  'more-alt',
  'more',
  'move-left-solid',
  'move-right-solid',
  'move-up-solid',
  'moving',
  'multi-device-solid',
  'multi-device',
  'music-solid',
  'music',
  'navigation-solid',
  'navigation',
  'node-solid',
  'node',
  'nodes-down-solid',
  'nodes-down',
  'nodes-left-solid',
  'nodes-left',
  'nodes-right-solid',
  'nodes-right',
  'nodes-up-solid',
  'nodes-up',
  'notepad-empty-solid',
  'notepad-empty',
  'notepad-solid',
  'notepad',
  'notes-solid',
  'notes',
  'object-case-multi',
  'object-case-solid',
  'object-case',
  'object-status',
  'open',
  'opportunity-solid',
  'opportunity',
  'or-delete',
  'os-android',
  'os-apple',
  'os-windows',
  'paper-clip',
  'passbook-solid',
  'passbook',
  'pause-solid',
  'pause',
  'paypal',
  'peekpanel-arrow-left-solid',
  'peekpanel-arrow-left',
  'peekpanel-arrow-right-solid',
  'peekpanel-arrow-right',
  'pega',
  'pegasus',
  'pen-solid',
  'pen',
  'pencil-solid',
  'pencil',
  'person-solid',
  'person',
  'phone-ai-solid',
  'phone-ai',
  'phone-call-solid',
  'phone-call',
  'phone-disabled-solid',
  'phone-disabled',
  'phone-hangup-solid',
  'phone-hangup',
  'phone-in-solid',
  'phone-in',
  'phone-list-solid',
  'phone-list',
  'phone-merge-solid',
  'phone-merge',
  'phone-out-solid',
  'phone-out',
  'phone-pause-solid',
  'phone-pause',
  'phone-solid',
  'phone-split-solid',
  'phone-split',
  'phone',
  'picture-solid',
  'picture',
  'piggybank-solid',
  'piggybank',
  'pin-solid',
  'pin',
  'pipeline-solid',
  'pipeline',
  'placeholder',
  'plane-solid',
  'plane',
  'plant-solid',
  'plant',
  'play-solid',
  'play',
  'playbook-solid',
  'playbook',
  'plug-solid',
  'plug',
  'plus-between-left-column',
  'plus-between-right-column',
  'plus-line-above-below',
  'plus-line-above',
  'plus-line-below',
  'plus-line-left',
  'plus-line-right',
  'plus',
  'podium-solid',
  'podium',
  'polaris-solid',
  'polaris',
  'pong-solid',
  'pong',
  'potion-solid',
  'potion',
  'power',
  'preview-collapse',
  'preview-expand',
  'preview',
  'print-solid',
  'print',
  'processor-solid',
  'processor',
  'progress-solid',
  'progress',
  'puzzle-solid',
  'puzzle',
  'qr',
  'quill',
  'rabbit',
  'radio-solid',
  'radio',
  'rain-solid',
  'rain',
  'receipt-solid',
  'receipt',
  'rectangle-solid',
  'rectangle',
  'reply-all-solid',
  'reply-all',
  'reply-solid',
  'reply',
  'reset',
  'retweet',
  'rewind-solid',
  'rewind',
  'robot-happy-solid',
  'robot-happy',
  'robot-sad-solid',
  'robot-sad',
  'robot-solid',
  'robot',
  'rocket-solid',
  'rocket',
  'roller-solid',
  'roller',
  'route-solid',
  'route',
  'row-delete',
  'row-insert',
  'row-left-fill',
  'row-right-fill',
  'row',
  'scale-down',
  'scale-up-solid',
  'scale-up',
  'school-solid',
  'school',
  'scissors',
  'script',
  'search-analytics-solid',
  'search-analytics',
  'search-case',
  'search-check',
  'search-close',
  'search-minus',
  'search-org',
  'search-plus',
  'search-solid',
  'search-table',
  'search',
  'semitruck-solid',
  'semitruck',
  'send-solid',
  'send',
  'server-cloud-solid',
  'server-cloud',
  'server-solid',
  'server',
  'sextant',
  'share-point-up-solid',
  'share-point-up',
  'share-solid',
  'share',
  'shield-solid',
  'shield',
  'shoe-solid',
  'shoe',
  'shuffle',
  'sigma',
  'signpost-solid',
  'signpost',
  'slideshow-solid',
  'slideshow',
  'snail',
  'snow',
  'social-solid',
  'social',
  'speaker-mute-solid',
  'speaker-mute',
  'speaker-on-solid',
  'speaker-on',
  'speaker-solid',
  'speaker',
  'spellcheck',
  'square-solid',
  'square',
  'star-mixed',
  'star-solid',
  'star',
  'steps-solid',
  'steps',
  'stethoscope-solid',
  'stethoscope',
  'stoplight-solid',
  'stoplight',
  'stopwatch-solid',
  'stopwatch',
  'store-solid',
  'store',
  'sun-solid',
  'sun',
  'swipe-left-solid',
  'swipe-left',
  'swipe-right-solid',
  'swipe-right',
  'table',
  'tablet-solid',
  'tablet',
  'tag-check-solid',
  'tag-check',
  'tag-close-solid',
  'tag-close',
  'tag-solid',
  'tag',
  'target-solid',
  'target',
  'temp-solid',
  'temp',
  'thumbs-down-solid',
  'thumbs-down',
  'thumbs-up-solid',
  'thumbs-up',
  'times',
  'todo-solid',
  'todo',
  'tow-truck-solid',
  'tow-truck',
  'tracer-solid',
  'tracer',
  'transform',
  'trash-solid',
  'trash',
  'triangle-mixed-left',
  'triangle-mixed-right',
  'triangle-solid',
  'triangle',
  'tribox-solid',
  'tribox',
  'trophy-solid',
  'trophy',
  'truck-solid',
  'truck',
  'tv-solid',
  'tv',
  'twitter',
  'umbrella-solid',
  'umbrella',
  'undo',
  'undock',
  'unindent',
  'unwrap',
  'upload',
  'user-check-solid',
  'user-check',
  'user-close-solid',
  'user-close',
  'user-female-solid',
  'user-female',
  'user-laptop',
  'user-list-solid',
  'user-list',
  'user-plus-solid',
  'user-plus',
  'user-question-mark-solid',
  'user-question-mark',
  'user-search-solid',
  'user-search',
  'user-solid',
  'user-star-solid',
  'user-star',
  'user',
  'users-solid',
  'users',
  'video-off',
  'video-solid',
  'video',
  'voicemail',
  'vr-solid',
  'vr',
  'walkie-solid',
  'walkie',
  'wallet-solid',
  'wallet',
  'wand',
  'warn-solid',
  'warn',
  'watch-solid',
  'watch',
  'waypoint-solid',
  'waypoint',
  'webcam-solid',
  'webcam',
  'whatsapp',
  'wifi-none',
  'wifi-off',
  'wifi',
  'wizard-solid',
  'wizard',
  'wrap',
  'wrench-solid',
  'wrench',
  'youtube'
] as const;

export default iconNames;

export type IconName = (typeof iconNames)[number];
